import {
  Iterator,
  IteratorResult,
  iteratorResultDone,
  iteratorResultNotDone
} from './Iterator';
import { RoseTree } from './RoseTree';

/**
 * Iterates over all the nodes in depth-first order, visiting the parent before its children.
 *
 * @param tree - The tree over which to iterate
 */
export function preOrderTraversal<T>(tree: RoseTree<T>): Iterator<T> {
  const stack: RoseTree<T>[] = [];
  stack.push(tree);
  return {
    next(): IteratorResult<T> {
      const current = stack.pop();
      if (current === undefined) {
        return iteratorResultDone;
      }
      for (let i = current.children.length - 1; i >= 0; i--) {
        stack.push(current.children[i]);
      }
      return iteratorResultNotDone(current.node);
    }
  };
}
